/**
 * --------------------------------------------------------------------------
 * NJ : AbstractFormControl.js
 * --------------------------------------------------------------------------
 */


import AbstractFormBaseInput from './AbstractFormBaseInput';
import Manipulator from 'nj-utils/manipulator';

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEFAULT_CONFIG = {
  requiredClasses: ['nj-form-control']
};

class AbstractFormControl extends AbstractFormBaseInput {
  constructor(Component, element, config) {
    super(Component, element, Manipulator.extend(true, DEFAULT_CONFIG, config));

    if (this.constructor === AbstractFormControl) {
      throw new TypeError('Abstract class "AbstractFormControl" cannot be instantiated directly');
    }
  }
}

export default AbstractFormControl;
